// extracted by mini-css-extract-plugin
export default {"shape":"Stats_shape__tKqS4","item":"Stats_item__YpSLM","gridItem":"Stats_gridItem__9v4NH"};